function checkString(value1: string, value2: string) {
  return value1.toLocaleLowerCase() === value2.toLocaleLowerCase();
}
export { checkString };

